/**
 * Errors returned by the Eloquor API.
 *
 * Every error response has shape `{ code, message }`. `code` is from a CLOSED
 * SET (the enum below) so the client can branch on it without parsing prose.
 * `message` is human-safe — no internal IDs, no DB rowids, no S3 keys.
 */
/** Helper for backend route handlers (re-used by frontend as a type guard). */
export function isApiError(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'code' in value &&
        typeof value.code === 'string' &&
        'message' in value &&
        typeof value.message === 'string');
}
//# sourceMappingURL=errors.js.map